(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mistrune-bundle-catalog"] && !Shopify.designMode) return;
  try {
    function createMistruneBundleMapper(config) {
  const bundles = new Map(config.bundles.map(bundle => [String(bundle.sourceId), bundle]));
  const oils = new Map();
  config.oils.forEach(oil => [oil.id, oil.title, oil.value].forEach(key => oils.set(String(key), oil)));
  const fail = reason => { throw Object.assign(new Error(reason), { code: reason, uncertain: false }); };
  const getBundle = id => bundles.get(String(id)) || fail('unknown_bundle');
  const item = (id, selections, properties = {}, quantity = 1) => {
    const bundle = getBundle(id);
    if (bundle.ready !== true) fail('catalog_not_ready');
    if (!Number.isSafeInteger(quantity) || quantity < 1) fail('invalid_quantity');
    if (!Array.isArray(selections) || selections.length !== bundle.count) fail('invalid_selection_count');
    const chosen = selections.map(value => oils.get(String(value)) || fail('unknown_fragrance'));
    const values = bundle.diffuser ? [bundle.diffuser] : [];
    values.push(...chosen.map(oil => oil.value));
    const resultProperties = { ...properties };
    Object.keys(resultProperties).forEach(key => {
      if (/^(?:Scent|Fragrance) \d+$/.test(key) || key === 'Diffuser' || key === '_bundle_selection') delete resultProperties[key];
    });
    if (bundle.diffuser) resultProperties.Diffuser = bundle.diffuser;
    chosen.forEach((oil,index) => { resultProperties['Fragrance ' + (index + 1)] = oil.title; });
    resultProperties._bundle_selection = values.join(' <> ');
    resultProperties._mistrune_bundle_version = 'sb2-catalog-v1';
    resultProperties._mistrune_source_variant = String(id);
    resultProperties._mistrune_source_handle = bundle.sourceHandle;
    delete resultProperties._mistrune_qa_case;
    if (config.qa === true) resultProperties._mistrune_qa_case = 'small-cart-20260913:entry:' + String(id) + ':' + Date.now();
    return { id: String(bundle.stagingId), quantity, properties: resultProperties };
  };
  const fromForm = data => {
    const identifiers = data.getAll('id').filter(Boolean);
    if (identifiers.length !== 1) fail('invalid_variant');
    const selected = [];
    const properties = {};
    for (const [name,value] of data.entries()) {
      const property = name.match(/^properties\[(.+)\]$/);
      if (!property) continue;
      properties[property[1]] = value;
      const scent = property[1].match(/^(?:Scent|Fragrance) (\d+)$/);
      if (scent) selected.push({index:Number(scent[1]),value});
    }
    selected.sort((a,b) => a.index-b.index);
    if (selected.some((entry,index) => entry.index !== index+1)) fail('invalid_selection_slots');
    return item(identifiers[0],selected.map(entry=>entry.value),properties,Number(data.get('quantity') || 1));
  };
  return Object.freeze({ item, fromForm, getBundle });
}

(() => {
  const initialise = () => {
    const node = document.getElementById('MistruneBundleCatalog');
    if (!node) return;
    const config = JSON.parse(node.textContent);
    if (config.mode !== 'production-candidate' || config.version !== 1) return;
    config.bundles.forEach(bundle => { bundle.priceCents = Math.round(Number(bundle.price) * 100); });
    config.qa = new URLSearchParams(window.location.search).get('bundle_qa') === 'catalog23';
    const mapper = createMistruneBundleMapper(config);
    window.MistruneBundleBridge = mapper;
    document.dispatchEvent(new CustomEvent('mistrune:bundle-ready'));
    const formSelector = '[data-grandwood-form], [data-bulb-form], [data-babel-form], [data-drive-form]';
    const bindForms = scope => {
      scope.querySelectorAll(formSelector).forEach(form => {
        if (form.dataset.bundleBridgeBound === 'true') return;
        form.dataset.bundleBridgeBound = 'true';
        const report = () => {
          const output = form.querySelector('[data-form-status]');
          if (output) output.textContent = node.dataset.pendingMessage;
        };
        form.addEventListener('formdata', event => {
          try {
            const mapped = mapper.fromForm(event.formData);
            event.formData.set('id',mapped.id);
            event.formData.set('quantity',String(mapped.quantity));
            for (const key of [...event.formData.keys()]) {
              if (/^properties\[(?:Scent|Fragrance) \d+\]$/.test(key)) event.formData.delete(key);
            }
            Object.entries(mapped.properties).forEach(([key,value]) => event.formData.set('properties['+key+']',value));
            event.formData.set('return_to',node.dataset.cartUrl);
            form.dataset.bundleBridgeError = '';
          } catch (error) {
            event.formData.delete('id');
            form.dataset.bundleBridgeError = error.code || 'invalid_bundle';
            report();
          }
        });
        form.addEventListener('submit', event => {
          const data = new FormData(form);
          if (!data.get('id') || form.dataset.bundleBridgeError) {
            event.preventDefault();
            event.stopImmediatePropagation();
            report();
          }
        },true);
      });
    };
    bindForms(document);
    document.addEventListener('shopify:section:load',event=>bindForms(event.target));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialise,{once:true});
  else initialise();
})();
  } catch(e) { console.error(e); }
})();

})();
